import axiosInstance from 'mf-shared/utils/axiosInstance';

export async function resetGoBizPassword(email) {
  try {
    await axiosInstance.post('/mkGoAuth/hermes/api/v1/password', {
      email,
    });
  } catch (error) {
    if (error?.response?.data?.errors?.email) {
      throw new Error(`Email ${error.response.data.errors.email.join(', ')}`);
    }
    throw error;
  }
}
